import { atom } from 'jotai';

export const SESSION_LIST_SPOTLIGHT_TOTAL_STEPS = 4;

export type SessionListSpotlightStep = 1 | 2 | 3 | 4;

/**
 * Current step of the session list spotlight tour, or null when not
 * running. The whole tour shares one modal-queue slot
 * (ModalId.NEW_SESSION_UPLOAD_SPOTLIGHT); stepping is internal and never
 * re-enters the queue.
 */
export const sessionListSpotlightStepAtom = atom<SessionListSpotlightStep | null>(null);

/**
 * Whether step 4's anchor — the expand/fullscreen control — is currently
 * mounted. It only renders in split/detail view, so when this is false the tour
 * ends at step 3; otherwise step 4 would have no anchor to attach to and no
 * visible button to close, stranding the user. Set by SessionListHeader.
 */
export const sessionListExpandAnchorAvailableAtom = atom(false);

/**
 * Whether the session list (with the tour's step 1-3 anchors) is actually
 * rendered — i.e. SessionsListPanel is mounted showing the list, not the
 * EHR-integration Appointments tabs. Set by SessionsListPanel.
 *
 * The tour only enqueues while this is true, so it never grabs the (HIGH) queue
 * slot on a surface where its anchors don't exist (EHR-appointments view, narrow
 * viewport where the panel isn't in the tree). Without this the tour could sit
 * queued and invisible, blocking every other launch modal for the session.
 */
export const sessionListAnchorsMountedAtom = atom(false);
